// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root__TCjkL","ribbon":"CustomButton_ribbon__4MMse"};